import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StudentCounsellingReportLinkComponent } from './student-counselling-report-link/student-counselling-report-link.component';

import { StudentCounsellingReportComponent } from './student-counselling-report/student-counselling-report.component';

const routes: Routes = [
    {
                path:'',component:StudentCounsellingReportLinkComponent,
                children:[
                  {
                    path:"studentCounsellingExcelReport", component:StudentCounsellingReportComponent
                  },  
                ]
              }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentCounsellingReportRoutingModule { }
